import gql from "graphql-tag";

export default gql`
	mutation sendOtp {
		sendOtp {
			success
		}
	}
`;
